import { Navigation } from "./navigation";
import { Header } from "./header";
import { Video } from "../contentelements/video";
import { DomHelper } from "../general/utils";

window.displayorientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';

export default class WindowEvents {
    constructor () {
        let _scope = this;
        this.ticking = false;

        this.scrollDirection = '';
        this.lastScrollPosition = window.pageYOffset;
        this.lastScrollPositionFixedHeaderDistace = parseInt(window.pageYOffset);

        this.onScroll = this.onScroll.bind(this);
        this.updateOnPageScroll = this.updateOnPageScroll.bind(this);

        window.onload = function (event) {
            _scope.load(event);
        };
    }

    load () {
        let e = DomHelper.isTouchDevice() ? 'orientationchange' : 'resize';
        document.documentElement.setAttribute('data-orientation', window.displayorientation);

        Navigation.initMenuButton();
        Navigation.initSubMenu();
        Video.init();

        window.addEventListener('scroll', this.onScroll, false);

        window.addEventListener(e, function () {
            setTimeout(function () {
                window.displayorientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';

                if(document.documentElement.getAttribute('data-orientation') !== window.displayorientation) {
                    document.documentElement.setAttribute('data-orientation', window.displayorientation);
                }

                Video.onM3u8Resize();
            }, 100);
        });
    }

    onScroll() {
        if(!this.ticking) {
            window.requestAnimFrame(this.updateOnPageScroll);
            this.ticking = true;
        }
    }

    updateOnPageScroll() {
        let newScrollPosition = window.pageYOffset;

        if (newScrollPosition < this.lastScrollPosition) {
            this.scrollDirection = 'up';

            if(newScrollPosition <= parseInt(this.lastScrollPositionFixedHeaderDistace - 150)) {
                Header.handleHeaderVisibility(this.scrollDirection);
                this.lastScrollPositionFixedHeaderDistace = newScrollPosition;
            }
        } else {
            this.scrollDirection = 'down';

            if(newScrollPosition >= this.lastScrollPositionFixedHeaderDistace + 100) {
                Header.handleHeaderVisibility(this.scrollDirection);
                this.lastScrollPositionFixedHeaderDistace = newScrollPosition;
            }
        }

        Video.init();

        this.lastScrollPosition = newScrollPosition;
        this.ticking = false;
    }
}